<style lang="scss" scoped>
@import "@/assets/css/variables.scss";
</style>
<template lang="pug">
  FormSection(
    :printOut="printOut"
    title="Family Information"
    description="The hope of this section is to capture a picture of your relational world."
  )
    YesNo(
      name="married"
      question="Are you married?"
      v-model="user.married"
      :printOut="printOut"
    )
    .frow.column.p-0(v-if="user.married")
      TextInput(
        v-model="user.nameOfSpouse"
        :printOut="printOut"
        example="Karli"
        name="nameOfSpouse"
        question="Spouses Name"
      )
      TextInput(
        v-model="user.anniversary"
        :printOut="printOut"
        placeholder="Anniversary"
        example="10 years, 7/19/09"
        name="anniversary"
        question="How long have you been married? When is your anniversary?"
      )
    .field.width-100
      YesNo(
        name="lossOfSpouse"
        question="Does your marital story include death, divorce, and/or remarriage?"
        v-model="user.lossOfSpouse"
        :printOut="printOut"
      )
    YesNo(
      name="kids"
      question="Do you have kids?"
      v-model="user.kids"
      :printOut="printOut"
    )
    .frow.column.p-0(v-if="user.kids")
      TextInput(
        v-model="user.kidsStageOfLife"
        :printOut="printOut"
        placeholder="Kids Information"
        example="Ella, 6/kindergarten; Violet, 4/preschool; Warren 3/toddler; Pearl, 1/toddler"
        name="kidsStageOfLife"
        question="What are your kids’ names, ages, and stages of life?"
      )
      YesNo(
        name="grandkids"
        question="Do you have any grandkids?"
        v-model="user.grandkids"
        :printOut="printOut"
      )
      .frow(v-if="user.grandkids")
        .col-md-1-2
          TextInput(
            v-model="user.numberOfGrandkids"
            :printOut="printOut"
            example="3"
            name="numberOfGrandkids"
            question="Number of Grandkids"
          )
        .col-md-1-2
          YesNo(
            name="moreGrandkids"
            question="Are you expecting (hoping) for more?"
            v-model="user.moreGrandkids"
            :printOut="printOut"
          )
      TextInput(
        v-model="user.blendedFamily"
        :printOut="printOut"
        example="Y, we experienced three miscarriages prior to the birth of our first child and Leslie’s parents are both divorced and remarried"
        name="blendedFamily"
        placeholder="Blended Family"
        question="Does your family story include blended family, adoption/fostering, or miscarriage/infertility?"
      )
    TextInput(
      v-model="user.origins"
      :printOut="printOut"
      example="Chicagoland, New Lenox, Southwest Suburbs"
      name="origins"
      question="Where are you from originally?"
    )
    TextInput(
      v-model="user.livedInBloomingtonNormal"
      :printOut="printOut"
      example="15-20 years"
      name="livedInBloomingtonNormal"
      question="How long have you lived in Bloomington-Normal?"
    )
    TextInput(
      v-model="user.broughtToBloomingtonNormal"
      :printOut="printOut"
      example="Illinois Wesleyan"
      name="broughtToBloomingtonNormal"
      question="What brought you to Bloomington-Normal initially?"
    )
    TextInput(
      v-model="user.stillInBloomingtonNormal"
      :printOut="printOut"
      example="Career"
      name="stillInBloomingtonNormal"
      question="Why are you in Bloomington-Normal now?"
    )
    TextInput(
      v-model="user.livedElsewhere"
      :printOut="printOut"
      example="Grew up in New Lenox"
      name="livedElsewhere"
      question="Have you lived significant periods of times in other places?"
    )

</template>
<script>
import FormSection from "@/new-components/GuideForm/FormSection";
import YesNo from "@/new-components/GuideForm/YesNo";
import TextInput from "@/new-components/GuideForm/TextInput";
export default {
  name: "family-information",
  components: {
    FormSection,
    YesNo,
    TextInput
  },
  props: {
    user: {
      type: Object
    },
    printOut: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({})
};
</script>
